module.exports = {
	"No notifications found.": "No notifications found.",
	"Notifications": "Notifications",
	"See all notifications": "Afficher toutes les notifications",
	"Mark all as read": "Mark all as read"
};


//////////////////
// WEBPACK FOOTER
// ./~/@99designs/globalnav/translations/fr.json
// module id = 902
// module chunks = 34